import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { OAuthProvider } from '../../../../login/services/oauth.service';

@Component({
  selector: 'app-login-providers',
  templateUrl: './login-providers.component.html',
  styleUrls: ['./login-providers.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class LoginProvidersComponent {
  @Input() providers: OAuthProvider[] = [];
  @Input() visible = false;
  @Input() isLoading = false;
  @Input() orgSsoLabel: string | null = null;

  @Output() google = new EventEmitter<void>();
  @Output() microsoft = new EventEmitter<void>();
  @Output() orgSso = new EventEmitter<void>();

  hasProvider(name: string): boolean {
    return this.providers.some(p => p.name === name);
  }
}
